export default "__VITE_ASSET__Dl1$AVM7__"